module.exports = __webpack_public_path__ + "img/EDIT.6e4d43ef.svg";